export const ALL_STATES: string[] = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois',
  'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts',
  'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
  'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
  'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
  'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
  'West Virginia', 'Wisconsin', 'Wyoming',
];

export interface ChoiceOption {
  value: string;
  label: string;
  description?: string;
}

export const ENTITY_OPTIONS: ChoiceOption[] = [
  { value: 'llc', label: 'LLC', description: 'Limited liability company' },
  { value: 'corporation', label: 'Corporation', description: 'C corporation or corporation with a tax election' },
  { value: 'personal', label: 'Sole Proprietor', description: 'Individual operating without a separate entity' },
  { value: 'partnership', label: 'Partnership', description: 'Two or more owners operating together' },
];

export const REVENUE_OPTIONS: ChoiceOption[] = [
  { value: 'preRevenue', label: 'Pre-revenue' },
  { value: 'under100k', label: 'Less than $100,000' },
  { value: '100kTo1m', label: '$100,000 to $1,000,000' },
  { value: 'over1m', label: 'More than $1,000,000' },
];

export const ASSETS_OPTIONS: ChoiceOption[] = [
  { value: 'under250k', label: 'Less than $250,000' },
  { value: '250kTo1m', label: '$250,000 to $1,000,000' },
  { value: 'over1m', label: 'More than $1,000,000' },
];

export const EMPLOYEE_OPTIONS: ChoiceOption[] = [
  { value: 'employees', label: 'W-2 Employees', description: 'Payroll employees' },
  { value: 'contractors', label: 'Independent Contractors', description: '1099 contractors' },
  { value: 'none', label: 'No Paid Workers', description: 'No payroll or contractor payments' },
];

export const YES_NO_OPTIONS: ChoiceOption[] = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

export interface AssessmentResponses {
  states: string[];
  foreignStates: string[];
  entity: string;
  revenue: string;
  assets: string;
  sellsGoodsOrServices: 'yes' | 'no' | '';
  hasPhysicalPresence: 'yes' | 'no' | '';
  hasEmployees: string[];
}

export const INITIAL_RESPONSES: AssessmentResponses = {
  states: [],
  foreignStates: [],
  entity: '',
  revenue: '',
  assets: '',
  sellsGoodsOrServices: '',
  hasPhysicalPresence: '',
  hasEmployees: [],
};

export type StepId =
  | 'states'
  | 'foreignStates'
  | 'entity'
  | 'revenue'
  | 'assets'
  | 'sellsGoodsOrServices'
  | 'hasPhysicalPresence'
  | 'hasEmployees';

export interface StepConfig {
  id: StepId;
  shortLabel: string;
  title: string;
  subtitle: string;
}

export const STEPS: StepConfig[] = [
  {
    id: 'states',
    shortLabel: 'Home states',
    title: 'Where is the company formed or based?',
    subtitle: 'Select every state where the company is formed, headquartered, or has an office.',
  },
  {
    id: 'foreignStates',
    shortLabel: 'Other states',
    title: 'Where else will it do business?',
    subtitle: 'Include states with employees, offices, inventory, or regular operations.',
  },
  {
    id: 'entity',
    shortLabel: 'Entity type',
    title: 'What type of company is it?',
    subtitle: 'Choose the legal structure or operating form.',
  },
  {
    id: 'revenue',
    shortLabel: 'Revenue',
    title: 'Expected annual gross revenue?',
    subtitle: 'Used to flag tax, license, and reporting thresholds.',
  },
  {
    id: 'assets',
    shortLabel: 'Assets',
    title: 'Approximate total company assets?',
    subtitle: 'Cash, inventory, equipment, property, and other owned assets.',
  },
  {
    id: 'sellsGoodsOrServices',
    shortLabel: 'Sales tax',
    title: 'Will it sell taxable goods or services?',
    subtitle: 'This helps identify sales tax permit requirements.',
  },
  {
    id: 'hasPhysicalPresence',
    shortLabel: 'Presence',
    title: 'Will it have physical presence outside its home state?',
    subtitle: 'Offices, warehouses, employees, inventory, or regular in-state operations can trigger registrations.',
  },
  {
    id: 'hasEmployees',
    shortLabel: 'Workers',
    title: 'What types of workers will it pay?',
    subtitle: 'Payroll and contractor payments create federal and state filings.',
  },
];
